import { createContext, useEffect, useState } from "react";
import Web3 from "web3";
import ERC20Abi from "../config/abis/ERC20.json";
import { STORE_TOKEN } from "../helpers";
export const contextWeb3 = createContext();

const ProviderWeb3 = ({ children }) => {
  const [web3, setWeb3] = useState("undefined");
  const [balanceStore, setBalanceStore] = useState(0.0);
  const [currentAccount, setCurrentAccount] = useState(null);
  const [isReturningUser, setIsReturningUser] = useState(false);
  const [msgNet, setMsgNet] = useState("");

  const checkWalletIsConnected = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      console.log("Make sure you have Metamask installed!");
      return;
    } else {
      console.log("Wallet exists! We're ready to go!");
    }

    const web3 = new Web3(window.ethereum);
    setWeb3(web3);

    const accounts = await ethereum.request({ method: "eth_accounts" });

    if (accounts.length !== 0) {
      const account = accounts[0];
      console.log("Found an authorized account: ", account);
      handleChangeAccount(accounts);
      await checkNetwork();
    } else {
      console.log("No authorized account found");
    }
  };

  const updateBalanceToken = async () => {
    const storeToken = new web3.eth.Contract(ERC20Abi, STORE_TOKEN);
    const balanceStore = await storeToken.methods
      .balanceOf(currentAccount)
      .call();

    setBalanceStore(web3.utils.fromWei(balanceStore.toString(), "ether"));
  };

  const connectWalletHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
      return;
    }

    try {
      if (isReturningUser) {
        const walletAddress = await ethereum.request({
          method: "eth_requestAccounts",
          params: [{}],
        });

        await window.ethereum.request({
          method: "wallet_requestPermissions",
          params: [
            {
              eth_accounts: {},
            },
          ],
        });

        handleChangeAccount(walletAddress);
      } else {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        console.log("Found an account! Address: ", accounts[0]);
        handleChangeAccount(accounts);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const logOut = async () => {
    setCurrentAccount(null);
    setIsReturningUser(true);
  };

  useEffect(() => {
    checkWalletIsConnected();
  }, []);

  const handleChangeAccount = async (account) => {
    setCurrentAccount(account[0]);
    const web3 = new Web3(window.ethereum);
    const storeToken = new web3.eth.Contract(ERC20Abi, STORE_TOKEN);
    const balanceStore = await storeToken.methods.balanceOf(account[0]).call();
    setBalanceStore(web3.utils.fromWei(balanceStore.toString(), "ether"));
  };

  const handleChangeNetwork = async () => {
    await checkNetwork();
    window.location.reload();
  };

  const checkNetwork = async () => {
    const web3 = new Web3(window.ethereum);
    const network = await web3.eth.net.getId();
    if (network !== 97) {
      setMsgNet(
        "Your are in the wrong network, this website only work in the testnet of binance smart chain"
      );
    } else if (network === 97) {
      setMsgNet("");
    }
  };

  if (window.ethereum) {
    window.ethereum.on("accountsChanged", handleChangeAccount);
    window.ethereum.on("chainChanged", handleChangeNetwork);
  }

  return (
    <contextWeb3.Provider
      value={{
        web3,
        currentAccount,
        balanceStore,
        connectWalletHandler,
        updateBalanceToken,
        logOut,
        msgNet,
      }}
    >
      {children}
    </contextWeb3.Provider>
  );
};

export default ProviderWeb3;
